import React from "react"
import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationLink,
  PaginationPrevious,
  PaginationNext,
} from "./UI/Pagination"

const DynamicPagination = ({ totalPages, pageNo, certificateIndex, pageNoChangeAction,certId }) => {

  const handlePageChange = (type, value) => {
    if (type === 'previous') {
      let value=(pageNo===1 || pageNo===0) ?0:Math.max(pageNo - 1, 1)
      pageNoChangeAction(value, certificateIndex,certId)
    }
    else if (type === 'current') {
      pageNoChangeAction(value-1, certificateIndex,certId)
    }
    else if (type === 'next') {
      let value=(pageNo + 1 === totalPages)?pageNo:Math.min(pageNo + 1, totalPages)
      pageNoChangeAction(value, certificateIndex,certId)
    }
  }

  return (
    <Pagination>
      <PaginationContent>
        <PaginationItem>
          <PaginationPrevious
            href="#"
            onClick={(e) =>{ e.preventDefault();  handlePageChange('previous', '')}
            }
          />
        </PaginationItem>
        {totalPages && [...Array(totalPages)].map((_, i) => (
          <PaginationItem key={i}>
            <PaginationLink
              href="#"
              isActive={parseInt(pageNo) == i}
              onClick={(e) =>{ e.preventDefault(); handlePageChange('current', i + 1)}
              }
            >
              {i + 1}
            </PaginationLink>
          </PaginationItem>
        ))}

        <PaginationItem>
          <PaginationNext
            href="#"
            onClick={(e) =>{ e.preventDefault();  handlePageChange('next', '')}}
          />
        </PaginationItem>
      </PaginationContent>
    </Pagination>
  )
}
export default DynamicPagination
